export default class MarcaInput {
    constructor (marca) {
        this.name = marca
    }

    static create(marca) {
        return new MarcaInput(marca)
    }
}